// import { useState, useEffect } from 'react';
import {  Smartphone } from 'lucide-react';

export const AppDownloadBanner = () => {
  // const [isVisible, setIsVisible] = useState(true);

  // useEffect(() => {
  //   // Check if user has dismissed the banner before
  //   const dismissed = localStorage.getItem('app-banner-dismissed');
  //   if (dismissed === 'true') {
  //     setIsVisible(false);
  //   }
  // }, []);

  // const handleDismiss = () => {
  //   setIsVisible(false);
  //   localStorage.setItem('app-banner-dismissed', 'true');
  // };

//   if (!isVisible) return null;

  return (
    <div className="bg-gradient-to-r from-primary-600/40 to-primary-700/60 py-8 px-4 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="container mx-auto max-w-6xl relative">
        {/* Close Button */}
        {/* <button
          onClick={handleDismiss}
          className="absolute top-0 right-0 text-white/80 hover:text-white transition-colors p-2"
          aria-label="Dismiss banner"
        >
          <X className="w-5 h-5" />
        </button> */}

        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Left Side - Text Content */}
          <div className="flex items-center gap-4 text-primary-800">
            <div className="bg-primary-100/50 p-4 rounded-2xl backdrop-blur-sm">
              <Smartphone className="w-8 h-8 md:w-10 md:h-10 text-primary-800" />
            </div>
            <div>
              <h3 className="text-xl md:text-2xl font-bold mb-1">
                Download the Sunrise Bookstore App
              </h3>
              <p className="text-primary-800/90 text-sm md:text-base">
                Shop faster, track orders, and get exclusive app-only deals!
              </p>
            </div>
          </div>

          {/* Right Side - Store Badges */}
          <div className="flex flex-col sm:flex-row gap-3">
            {/* Google Play Store Badge */}
            <a
              href="https://play.google.com/store/apps/details?id=com.bookmybook.app" // TODO: Update with actual Play Store URL
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform hover:scale-105 active:scale-95"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
                className="h-12 md:h-14"
              />
            </a>

            {/* Apple App Store Badge */}
            <a
              href="https://apps.apple.com/in/app/bookmybook-store/id6756175578" // TODO: Update with actual App Store URL
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform hover:scale-105 active:scale-95"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
                alt="Download on the App Store"
                className="h-12 md:h-14"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
